import { CameraFilters } from '../../../camera/repository/camera-api.repository.types';
import {
  CameraState,
  RawFilters,
} from '../../../camera/service/camera-api.service.types';

export class FetchCamerasHorus {
  static readonly type = '[Horus] Fetch Cameras';
  constructor(readonly filters: CameraFilters) {}
}

export class SaveRawFiltersHorus {
  static readonly type = '[Horus] Save Raw Filters';
  constructor(readonly rawFilters: RawFilters) {}
}

export class UpdateCameraState {
  static readonly type = '[Horus] Update Camera State';
  constructor(
    readonly cameraId: number,
    readonly state: CameraState,
  ) {}
}
